import { IStore } from "../types/IStore";

export const intentSecret = (state: IStore) => state.payment.clientSecret;
export const upgradePackageResult = (state: IStore) => state.payment.upgradeResult;
export const bookingStatusSelect = (state: IStore) => state.payment.bookingStatus;
export const transactionsPdfSelect = (state: IStore) => state.payment.transactionsPdf
export const paymentPackageDetails = (state: IStore) => state.payment.paymentPackages;
export const paymentInvoicePdf = (state: IStore) => state.payment.invoicePdf;